// - Filters Facturas
export default [
    {
        field: 'pch_provider_id',
        value: [],
        label: 'Proveedor',
        options: [],
    },
]
